<template>
  <div class="scheduled-promotion-raffles-form">
    <a-spin :spinning="loading" :tip="labels.form.loading">
      <ValidationObserver ref="observer">
        <a-form
          :model="form"
          :label-width="80"
          slot-scope="{ validate }"
          @submit.prevent="validate().then(handleSubmit)"
        >
          <a-row
            type="flex"
            justify="space-between"
            :gutter="16"
            :style="{ marginBottom: '15px' }"
          >
            <!-- Title -->
            <a-col :xs="24" :md="12">
              <h2 class="form-title">
                <a-icon :type="isEdit ? 'edit' : 'form'" class="form-icon" />
                <span>{{
                  isEdit
                    ? `${labels.form.titleView} número: ${form.code || ""}`
                    : labels.form.titleProcess
                }}</span>
              </h2>
            </a-col>
            <!-- Actions -->
            <a-col :xs="24" :md="12">
              <a-row
                type="flex"
                justify="end"
                :gutter="16"
                :style="{
                  alignItems: 'flex-end',
                  marginBottom: '0px',
                }"
              >
                <a-col>
                  <a-button-group>
                    <a-button
                      :type="isEdit ? 'primary' : 'danger'"
                      ghost
                      @click="handleCancel"
                      icon="arrow-left"
                    >
                      <span>{{ labels.form.goBack }}</span>
                    </a-button>
                    <a-button
                      v-if="!isMobile && canEdit"
                      type="primary"
                      ghost
                      :loading="submitting"
                      @click="validate().then(() => handleSubmit(true))"
                    >
                      <span>{{ labels.form.saveAndClose }}</span>
                    </a-button>
                    <a-button
                      v-if="canEdit"
                      type="primary"
                      :loading="submitting"
                      @click="validate().then(handleSubmit)"
                    >
                      <span>{{ labels.form.save }}</span>
                    </a-button>
                    <a-dropdown :trigger="['click']" v-if="isMobile && canEdit">
                      <a-menu slot="overlay">
                        <a-menu-item
                          key="1"
                          @click="validate().then(() => handleSubmit(true))"
                          >{{ labels.form.saveAndClose }}</a-menu-item
                        >
                      </a-menu>
                      <a-button type="primary" ghost icon="more" />
                    </a-dropdown>
                  </a-button-group>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-row type="flex" justify="center">
            <a-col :span="24">
              <a-card>
                <a-row type="flex" :gutter="24">
                  <a-col :xs="24" :sm="24" :md="3">
                    <switch-input
                      :vid="labels.form.status.label"
                      :name="labels.form.status.label"
                      v-model.lazy="form.isActive"
                      :label="labels.form.status.label"
                      :disabled="!canEdit"
                    />
                  </a-col>
                </a-row>
                <a-row type="flex" justify="start">
                  <a-col :xs="24" :sm="24" :md="12">
                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <date-picker
                          v-model="form.scheduled_start_date"
                          :vid="labels.form.scheduled_start_date.label"
                          :name="labels.form.scheduled_start_date.label"
                          :formitem="{
                            label: labels.form.scheduled_start_date.label,
                          }"
                          :placeholder="
                            labels.form.scheduled_start_date.placeholder
                          "
                          :format="dateFormat"
                          :showTime="{
                            use12Hours: true,
                            format: 'hh:mm A',
                          }"
                          rules="required"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <date-picker
                          v-model="form.scheduled_end_date"
                          :vid="labels.form.scheduled_end_date.label"
                          :name="labels.form.scheduled_end_date.label"
                          :formitem="{
                            label: labels.form.scheduled_end_date.label,
                          }"
                          :placeholder="
                            labels.form.scheduled_end_date.placeholder
                          "
                          :format="dateFormat"
                          :showTime="{
                            use12Hours: true,
                            format: 'hh:mm A',
                          }"
                          :use12Hours="true"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="24">
                        <Input
                          v-model="form.title"
                          :vid="labels.form.title_f.label"
                          :label="labels.form.title_f.label"
                          :name="labels.form.title_f.label"
                          :formitem="{ label: labels.form.title_f.label }"
                          :placeholder="labels.form.title_f.placeholder"
                          rules="required"
                          :readOnly="!canEdit"
                        />
                      </a-col>
                    </a-row>
                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <select-validation
                          v-model="form.raffle_type"
                          :placeholder="labels.form.raffle_type.placeholder"
                          :label="labels.form.raffle_type.label"
                          :dataSource="raffle_types"
                          :allowClear="true"
                          rules="required"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <Input
                          type="number"
                          v-model="form.amount_per_ticket"
                          :vid="labels.form.amount_per_ticket.label"
                          :label="
                            form.raffle_type === 'non_winning_orders'
                              ? labels.form.amount_per_ticket.label2
                              : labels.form.amount_per_ticket.label
                          "
                          :name="labels.form.amount_per_ticket.label"
                          :formitem="{
                            label: labels.form.amount_per_ticket.label,
                          }"
                          :placeholder="
                            labels.form.amount_per_ticket.placeholder
                          "
                          :min="1"
                          rules="required"
                          :readOnly="!canEdit"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <Input
                          type="number"
                          v-model="form.start_sequence"
                          :vid="labels.form.start_sequence.label"
                          :label="labels.form.start_sequence.label"
                          :name="labels.form.start_sequence.label"
                          :formitem="{
                            label: labels.form.start_sequence.label,
                          }"
                          :placeholder="labels.form.start_sequence.placeholder"
                          :min="0"
                          rules="required"
                          :readOnly="!canEdit"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <Input
                          type="number"
                          v-model="form.end_sequence"
                          :vid="labels.form.end_sequence.label"
                          :label="labels.form.end_sequence.label"
                          :name="labels.form.end_sequence.label"
                          :formitem="{ label: labels.form.end_sequence.label }"
                          :placeholder="labels.form.end_sequence.placeholder"
                          :min="form.start_sequence ? form.start_sequence : 0"
                          rules="required"
                          :readOnly="!canEdit"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <select-pagination
                          ref="lotterySelect"
                          v-model="form.lottery"
                          :fetchService="fetchLotteries"
                          :placeholder="labels.form.lottery.placeholder"
                          :labelKey="'name'"
                          :valueKey="'id'"
                          :disabledDefaultFetchOptions="false"
                          :label="labels.form.lottery.label"
                          :allowClear="true"
                          :customStyle="{ width: '100%' }"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <select-validation
                          v-model="form.play_type"
                          :placeholder="labels.form.play_type.placeholder"
                          :label="labels.form.play_type.label"
                          :dataSource="play_types"
                          :allowClear="true"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <select-validation
                          v-model="form.prize_type"
                          :placeholder="labels.form.prize_type.placeholder"
                          :label="labels.form.prize_type.label"
                          :dataSource="prize_types"
                          :allowClear="true"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <Input
                          v-if="form.prize_type === 'CASH'"
                          type="number"
                          v-model="form.prize_amount"
                          :vid="labels.form.prize_amount.label"
                          :label="
                            form.raffle_type === 'non_winning_orders'
                              ? labels.form.prize_amount.label2
                              : labels.form.prize_amount.label
                          "
                          :name="labels.form.prize_amount.label"
                          :formitem="{
                            label: labels.form.prize_amount.label,
                          }"
                          :placeholder="labels.form.prize_amount.placeholder"
                          :min="1"
                          rules="required"
                          :readOnly="!canEdit"
                          :disabled="!canEdit"
                        />
                        <Input
                          v-else-if="form.prize_type === 'PRODUCT'"
                          v-model="form.prize_product"
                          :vid="labels.form.prize_product.label"
                          :label="labels.form.prize_product.label"
                          :name="labels.form.prize_product.label"
                          :formitem="{ label: labels.form.prize_product.label }"
                          :placeholder="labels.form.prize_product.placeholder"
                          rules="required"
                          :readOnly="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row
                      v-if="form.prize_type === 'PRODUCT'"
                      type="flex"
                      justify="space-between"
                      :gutter="24"
                    >
                      <a-col :xs="24" :sm="24" :md="24">
                        <Input
                          v-model="form.prize_product_image"
                          :vid="labels.form.prize_product_image.label"
                          :label="labels.form.prize_product_image.label"
                          :name="labels.form.prize_product_image.label"
                          :formitem="{
                            label: labels.form.prize_product_image.label,
                          }"
                          :placeholder="
                            labels.form.prize_product_image.placeholder
                          "
                          :readOnly="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="24">
                        <text-area
                          v-model="form.prize_product_description"
                          rules="required"
                          vid="message"
                          :placeholder="
                            labels.form.prize_product_description.placeholder
                          "
                          size="large"
                          :allowClear="true"
                          :readOnly="!canEdit"
                          :label="labels.form.prize_product_description.label"
                          :autoSize="{ minRows: 2, maxRows: 6 }"
                        />
                      </a-col>
                    </a-row>

                    <a-row
                      v-if="form.prize_type === 'CASH'"
                      type="flex"
                      justify="space-between"
                      :gutter="24"
                    >
                      <a-col :xs="24" :sm="24" :md="12">
                        <select-validation
                          v-model="form.initial_amount_type"
                          :placeholder="
                            labels.form.initial_amount_type.placeholder
                          "
                          :label="labels.form.initial_amount_type.label"
                          :dataSource="amount_types"
                          :allowClear="true"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <Input
                          type="number"
                          v-model="form.initial_quantity"
                          :vid="labels.form.initial_quantity.label"
                          :label="labels.form.initial_quantity.label"
                          :name="labels.form.initial_quantity.label"
                          :formitem="{
                            label: labels.form.initial_quantity.label,
                          }"
                          :placeholder="
                            labels.form.initial_quantity.placeholder
                          "
                          :min="1"
                          v-bind="
                            form.initial_amount_type === 'FIXED'
                              ? {}
                              : { max: 100, precision: 2 }
                          "
                          rules="required"
                          :readOnly="!canEdit"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row
                      v-if="form.prize_type === 'CASH'"
                      type="flex"
                      justify="space-between"
                      :gutter="24"
                    >
                      <a-col :xs="24" :sm="24" :md="12">
                        <select-validation
                          v-model="form.cumulative_amount_type"
                          :placeholder="
                            labels.form.cumulative_amount_type.placeholder
                          "
                          :label="labels.form.cumulative_amount_type.label"
                          :dataSource="amount_types"
                          :allowClear="true"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <Input
                          type="number"
                          v-model="form.cumulative_quantity"
                          :vid="labels.form.cumulative_quantity.label"
                          :label="labels.form.cumulative_quantity.label"
                          :name="labels.form.cumulative_quantity.label"
                          :formitem="{
                            label: labels.form.cumulative_quantity.label,
                          }"
                          :placeholder="
                            labels.form.cumulative_quantity.placeholder
                          "
                          :min="1"
                          v-bind="
                            form.cumulative_amount_type === 'FIXED'
                              ? {}
                              : { max: 100, precision: 2 }
                          "
                          rules="required"
                          :readOnly="!canEdit"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </a-card>
            </a-col>
          </a-row>
        </a-form>
      </ValidationObserver>
    </a-spin>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import labels from "@/utils/labels";
import Input from "@/components/core/VeeValidateForm/Input.vue";
import DatePicker from "@/components/core/VeeValidateForm/DatePicker.vue";
import TextArea from "@/components/core/VeeValidateForm/TextArea.vue";
import SelectPagination from "@/components/core/SelectPagination/index.vue";
import SelectValidation from "@/components/core/VeeValidateForm/Select.vue";
import SwitchInput from "@/components/core/VeeValidateForm/Switch.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";
import moment from "moment";
import router from "@/router";
import { mask } from "vue-the-mask";
import { adminPageTitle, hasRoles, roles } from "../../../utils/utils";

const RAFFLE_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

const initialFormState = {
  title: "",
  raffle_type: "deposit_transaction",
  start_sequence: 0,
  end_sequence: 0,
  scheduled_start_date: moment().startOf("day"),
  scheduled_end_date: moment().endOf("day"),
  amount_per_ticket: 1,
  status: RAFFLE_STATUS.ACTIVE,
  lottery: null,
  play_type: "pick3",
  prize_type: "CASH",
  prize_amount: 0,
  prize_product: "",
  prize_product_image: "",
  prize_product_description: "",
  initial_amount_type: "FIXED",
  initial_quantity: 0,
  cumulative_amount_type: "FIXED",
  cumulative_quantity: 0,
  isActive: true,
};

export default {
  name: "ScheduledPromotionRaffleForm",
  directives: { themask: mask },
  components: {
    ValidationObserver,
    Input,
    DatePicker,
    TextArea,
    SelectPagination,
    SelectValidation,
    SwitchInput,
  },
  metaInfo: {
    title: adminPageTitle(labels.scheduledPromotionRaffles.title),
    titleTemplate: () => {
      return `${adminPageTitle()} - ${
        router.currentRoute.name.includes("view")
          ? labels.scheduledPromotionRaffles.pageTitleViewing
          : labels.scheduledPromotionRaffles.pageTitleCreate
      }`;
    },
  },
  filters: {
    ucwords(value) {
      if (!value) return "";
      value = value.toString();
      return value
        .split(" ")
        .map((item) => _.capitalize(item))
        .join(" ");
    },
  },
  data() {
    return {
      labels: labels.scheduledPromotionRaffles,
      loading: false,
      submitting: false,
      type: undefined,
      form: _.cloneDeep(initialFormState),
      showTickets: false,
      raffle_types: [
        {
          label:
            labels.scheduledPromotionRaffles.form.raffle_type
              .deposit_transaction,
          value: "deposit_transaction",
        },
        {
          label:
            labels.scheduledPromotionRaffles.form.raffle_type
              .non_winning_orders,
          value: "non_winning_orders",
        },
      ],
      prize_types: [
        {
          label: labels.scheduledPromotionRaffles.form.prize_type.cash,
          value: "CASH",
        },
        {
          label: labels.scheduledPromotionRaffles.form.prize_type.product,
          value: "PRODUCT",
        },
      ],
      play_types: [
        {
          label: labels.scheduledPromotionRaffles.form.play_type.pick3,
          value: "pick3",
        },
        {
          label: labels.scheduledPromotionRaffles.form.play_type.pick4,
          value: "pick4",
        },
      ],
      amount_types: [
        {
          label: labels.scheduledPromotionRaffles.form.amount_type.fixed,
          value: "FIXED",
        },
        {
          label: labels.scheduledPromotionRaffles.form.amount_type.percentage,
          value: "PERCENTAGE",
        },
      ],
    };
  },
  async created() {
    this.resetForm();
    if (this.$route.params.id) {
      this.fetchData();
    }
  },
  computed: {
    ...mapState("scheduledPromotionRaffles", ["scheduledPromotionRaffle"]),
    ...mapState("layout", ["screenWidth"]),
    ...mapGetters("adminAuth", ["getLoggedUser"]),
    isEdit() {
      return !!this.$route.params?.id;
    },
    locale() {
      return {
        emptyText: this.labels.table.ticketEmptyText,
      };
    },
    canEdit() {
      const { accessRoles } = this.getLoggedUser;
      return (
        !this.isEdit ||
        hasRoles(accessRoles, [
          roles.admin.ROLE_SCHEDULED_PROMOTION_RAFFLES_UPDATE,
        ])
      );
    },
    canClose() {
      if (this.scheduledPromotionRaffle?.status === RAFFLE_STATUS.CLOSED) {
        return false;
      }
      const { accessRoles } = this.getLoggedUser;
      return hasRoles(accessRoles, [
        roles.admin.ROLE_SCHEDULED_PROMOTION_RAFFLES_CLOSE,
      ]);
    },
    canInitiate() {
      const { accessRoles } = this.getLoggedUser;
      return (
        hasRoles(accessRoles, [
          roles.admin.ROLE_SCHEDULED_PROMOTION_RAFFLES_INITIATE,
        ]) && this.form?.status === RAFFLE_STATUS.PENDING
      );
    },
    dateFormat() {
      return "DD/MM/YYYY hh:mm A";
    },
    serverDateFormat() {
      return "YYYY-MM-DD HH:mm:ss";
    },
    money() {
      return {
        decimal: ".",
        thousands: ",",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      };
    },
    isMobile() {
      return this.screenWidth < 768;
    },
  },
  methods: {
    ...mapActions("scheduledPromotionRaffles", [
      "fetchScheduledPromotionRaffleTickets",
      "fetchScheduledPromotionRaffle",
      "createScheduledPromotionRaffle",
      "updateScheduledPromotionRaffle",
      "resetForm",
    ]),
    ...mapActions("lotteries", ["fetchLotteries"]),
    ...mapActions("users", ["fetchUsers"]),
    async fetchData() {
      try {
        this.loading = true;
        await this.fetchScheduledPromotionRaffle(this.$route.params.id);
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message ||
            error?.response?.message ||
            error.message
        );
        this.$log.error(error);
        this.$router.push({ name: "admin.scheduled-promotion-raffles" });
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit(closeAfterSave = false) {
      if (this.submitting) return;
      this.submitting = true;
      let response = null;
      let editting = this.isEdit;
      try {
        const formData = _.cloneDeep(this.form);
        formData.scheduled_start_date = moment(
          formData.scheduled_start_date
        ).format(this.serverDateFormat);
        if (formData.scheduled_end_date) {
          formData.scheduled_end_date = moment(
            formData.scheduled_end_date
          ).format(this.serverDateFormat);
        } else {
          delete formData.scheduled_end_date;
        }

        response = editting
          ? await this.updateScheduledPromotionRaffle(formData)
          : await this.createScheduledPromotionRaffle(formData);

        if (response) this.$message.success(response.message);
        if (closeAfterSave) {
          this.$router.push({ name: "admin.scheduled-promotion-raffles" });
        } else {
          if (!editting) {
            this.$router.push({
              name: "admin.scheduled-promotion-raffles.edit",
              params: { id: response.data.id },
            });
          }
        }
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message ||
            error?.response?.message ||
            error.message
        );
      } finally {
        this.submitting = false;
      }
    },
    handleCancel() {
      this.$router.push({ name: "admin.scheduled-promotion-raffles" });
    },
  },
  watch: {
    "$route.params.id"(value, oldValue) {
      if (value && value !== oldValue) {
        this.fetchData();
      }
    },
    scheduledPromotionRaffle: {
      handler(value) {
        Object.assign(
          this.form,
          value
            ? {
                ..._.cloneDeep(value),
                isActive: value.status === RAFFLE_STATUS.ACTIVE,
              }
            : _.cloneDeep(initialFormState)
        );
      },
      deep: true,
    },
    "form.isActive": {
      handler(value, oldVal) {
        if (value !== oldVal) {
          this.form.status = value
            ? RAFFLE_STATUS.ACTIVE
            : RAFFLE_STATUS.INACTIVE;
        }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    this.form = _.cloneDeep(initialFormState);
    this.resetForm();
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.scheduled-promotion-raffles-form {
  .form-title {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .form-icon {
    margin-right: 8px;
  }
  .form-button-group {
    margin-top: 16px;
  }
}
::v-deep {
  .ant-input[disabled],
  .ant-time-picker-input[disabled],
  .ant-input-number-disabled,
  .ant-select-disabled .ant-select-selection {
    background-color: color(--white) !important;
    color: rgba(0, 0, 0, 0.65) !important;
  }
}
</style>
<style lang="scss">
@import "~@/assets/scss/variable";
.scheduled-promotion-raffles-form {
  .list-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    &-head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 6px;
      &-header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 2px;
        max-width: 25%;
        width: 25%;
        border-right: 4px solid color(border);
        .success {
          color: color(success);
        }
        .warning {
          color: color(warning);
        }
        .danger {
          color: color(danger);
        }
        span {
          font-size: 14px;
          font-weight: 600;
        }
        small {
          font-size: 12px;
          font-weight: 400;
          padding-right: 4px;
        }
      }
      &-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 2px;
        max-width: 50%;
        width: 50%;
        overflow: hidden;
        &-name,
        &-ticket_number {
          span {
            font-size: 16px;
            font-weight: 700;
            text-overflow: ellipsis;
          }
        }
        &-reference {
          span {
            font-size: 14px;
            font-weight: 500;
            text-overflow: ellipsis;
          }
        }
      }
      &-footer {
        max-width: 25%;
        width: 25%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: right;
        gap: 2px;
        &-status {
          width: 100%;
          span {
            font-size: 12px;
            font-weight: 400;
          }
          .ant-tag {
            padding: 0;
            margin: 0;
            padding-left: 2px;
            padding-right: 2px;
          }
        }
      }
    }
    &-actions {
      width: 100%;
      margin-top: 10px;
      .ant-btn-group {
        width: 100%;
        .more-info-button,
        .edit-button,
        .delete-button {
          width: 100%;
        }
      }
    }
  }
  .radio-view {
    display: flex;
    margin-bottom: 15px;
  }
  .radio-mobile-view {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
  }
}
</style>
